import { ReactComponent as ChevronRight } from '../../../assets/chevron-right.svg'

export const ChevronRightIcon = () => (
    <ChevronRight height="40" />
)
